import { render, staticRenderFns } from "./newEvent.vue?vue&type=template&id=7794e70c&scoped=true"
import script from "./newEvent.vue?vue&type=script&lang=js"
export * from "./newEvent.vue?vue&type=script&lang=js"
import style0 from "./newEvent.vue?vue&type=style&index=0&id=7794e70c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7794e70c",
  null
  
)

export default component.exports